/* eslint-disable react/no-array-index-key */
/* eslint-disable jsx-a11y/media-has-caption */
/* eslint-disable no-return-assign */
/**
 * @name Eglise EMIA
 * @author Mr. Josia Yvan
 * @description System API and Management System Software ~ Developed By Mr. Josia Yvan
 * @copyright ©2025 ― Mr. Josia Yvan. All rights reserved.
 * @version v0.0.1
 *
 */
import React, { useEffect, useState } from 'react';
import { useMediasoup } from '../hooks/mediasoup';

function Call() {
  window.document.title = 'Eglise EMIA — Call';

  const { localVideo, remoteVideos } = useMediasoup('user123'); // passer ton userId
  const [streams, setStreams] = useState([]);

  useEffect(() => {
    const interval = setInterval(() => {
      setStreams([...remoteVideos.current]); // mettre à jour liste remote
    }, 1000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div>
      <h2>Ma visioconférence</h2>
      <video ref={localVideo} autoPlay playsInline muted width='200' />
      <div className='grid grid-cols-3 gap-2 mt-4'>
        {streams.map((s, i) => (
          <video key={i} autoPlay playsInline ref={(el) => el && (el.srcObject = s)} width='200' />
        ))}
      </div>
    </div>
  );
}

export default Call;
